// src/pages/Dashboard/Admin/SeasonStats/components/SeasonGroupsCard.jsx

import React, { useMemo } from "react";

import { getGroupRows } from "../utils/seasonStatsDashboardUtils";

export default function SeasonGroupsCard({
  seasonStat,
}) {
  const groups = useMemo(
    () => getGroupRows(seasonStat),
    [seasonStat],
  );

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
          Groupes
        </p>

        <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
          Effectifs et remplissage
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
          Visualisez les effectifs enregistrés et le quota
          éventuel de chaque groupe.
        </p>

        {groups.length === 0 ? (
          <div className="mt-5 rounded-2xl bg-slate-50 px-4 py-10 text-center text-sm text-slate-500 dark:bg-slate-800/40 dark:text-slate-400">
            Aucun groupe enregistré pour cette saison.
          </div>
        ) : (
          <div className="mt-5 grid grid-cols-1 gap-3 lg:grid-cols-2">
            {groups.map((group) => {
              const progress =
                group.fillRate === null
                  ? null
                  : Math.min(
                      group.fillRate,
                      100,
                    );

              return (
                <article
                  key={group.id || group.code}
                  className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-800/40"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="truncate text-sm font-bold text-slate-900 dark:text-white">
                        {group.label}
                      </p>

                      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                        {group.capacity !== null
                          ? `${group.value} adhérent(s) sur ${group.capacity}`
                          : `${group.value} adhérent(s)`}
                      </p>
                    </div>

                    {group.fillRate !== null ? (
                      <span
                        className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-bold ${
                          group.fillRate >= 100
                            ? "bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300"
                            : group.fillRate >= 85
                              ? "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300"
                              : "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300"
                        }`}
                      >
                        {group.fillRate}%
                      </span>
                    ) : null}
                  </div>

                  {progress !== null ? (
                    <div className="mt-4 h-2.5 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="h-full rounded-full bg-[#013E8E] transition-all"
                        style={{
                          width: `${progress}%`,
                        }}
                      />
                    </div>
                  ) : null}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}